export const CHART_TABS_TRANSLATIONS = {
  ALL_MY_ACCOUNTS: (totalCompanies, updateDate) =>
    `Mes ${totalCompanies} comptes bancaires au ${updateDate}`,
  SINGLE_BANK_ACCOUNT: 'Mon compte bancaire au {{UPDATE_DATE}}',
  OTHER_ACCOUNTS: '{{COMPANIES_COUNT}} autres comptes',
  HORIZONTAL_ALL_ACCOUNTS: 'Tous les comptes',
  ALL_ACCOUNTS_FOR_SELECT: 'Cout entreprise',
};
